import { computed } from 'vue'

export function useDetailViewCommons(meta) {
  const allowsAnnotations = computed(
    () => meta.value?.model?.annotatable === true,
  )
  const allowsAttachments = computed(
    () => meta.value?.model?.attachmentable === true,
  )
  const allowsOrders = computed(() => meta.value?.model?.orderable === true)
  const allowsNotes = computed(() => meta.value?.model?.noteable === true)
  const allowsShipments = computed(() => meta.value?.model?.shippable === true)

  return {
    allowsAnnotations,
    allowsAttachments,
    allowsOrders,
    allowsNotes,
    allowsShipments,
  }
}
